import posthog from 'posthog-js'

export const handleCookiesChange = (consent) => {
  if (consent) {
    posthog.opt_in_capturing()
    localStorage.setItem('ph_enabled', '1')
  } else {
    posthog.opt_out_capturing()
    localStorage.setItem('ph_enabled', '0')
  }
}
